import React from 'react';
import { Card, CardContent, CardMedia, Container, Divider, Grid, Typography } from '@mui/material';
import styles from './Blog.module.css';
import { BLOGS } from '../../Datasets/Blogs';


const BlogPost = (blog) => {
  return (
    <Card className={styles.card}>
      <CardMedia
        component="img"
        height="194"
        image={blog.link}
        alt={blog.title}
        className={styles.image}
      />
      <CardContent>
        <Typography variant="h5" gutterBottom className={styles.title}>
          {blog.title}
        </Typography>
        <Typography variant="body1" paragraph>
          {blog.content}
        </Typography>
      </CardContent>
      <Divider />
    </Card>
  );
};



const Blog = () => {
  return (
    <Container sx={{ padding: "0 !important", maxWidth: "100% !important" }}>
        <h1 className={styles.heading}><b>Blogs</b></h1>
      <Grid container spacing={2} sx={{padding:"1rem"}}>
        {BLOGS && BLOGS.map((blog, index) => (
          <Grid item xs={12} md={6} key={index}>
            <BlogPost title={blog.title} content={blog.content} link={blog.link} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Blog;
